<template>
  <layout-component>
    <div class="banner banner-booking-success">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center pb-2 pb-md-3">
          <div class="col-md-8 col-lg-7 col-xl-6">
            <h1 class="left-bullet">404</h1>
            <p>{{ 'text-01'|t }}</p>
            <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/" active-class="active">{{ 'title-btn'|t }}</router-link>
          </div>
        </div>
      </div>
    </div>
	</layout-component>
</template>

<script>
    export default {
        mounted() {

        }
    }
</script>

<i18n>
    {
      "en": {
        "text-01": "The page you were looking for doesn't exist",
        "title-btn": "Back to homepage"
      },
      "fr": {
        "text-01": "La page que vous recherchez n'existe pas",
        "title-btn": "Retour à l'accueil"
      }
    }

  </i18n>
